// extracted by mini-css-extract-plugin
export var navLinks = "menu-module--nav-links--Ixl-V";
export var navLinkItem = "menu-module--nav-link-item--fP109";
export var navLinkText = "menu-module--nav-link-text--mkDtk";
export var navLinkTextActive = "menu-module--nav-link-text-active--lO5dI";